<template>
  <div class="login-wrapper">
    <div class="login-logo">
      <img :src="require('@/assets/img/title.png')" @click="toLogin" />
    </div>
    <div v-if="!step" class="login-content-box">
      <div class="login-content flex flex-col flex-center">
        <div class="form-wrapper flex flex-col align-center">
          <div class="form-header">密码找回</div>
          <a-form :form="form" class="login-form" autocomplete="new-password">
            <a-form-item>
              <a-input
                v-decorator="['mobile', {initialValue: formData.mobile, rules: [{ validator: cellPhoneValidator, trigger: 'change'}]}]"
                allow-clear
                :max-length="11"
                placeholder="请输入手机号"
                @change="getFieldsValueData"
              >
                <img slot="prefix" src="@/assets/img/user.png" alt />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                v-decorator="['picCaptcha', {initialValue: formData.picCaptcha,rules: [{ required: true, message: '请输入图片验证码', whitespace: true}]}]"
                placeholder="请输入右图中的字符"
                :max-length="4"
                @change="getFieldsValueData"
              >
                <img slot="prefix" src="@/assets/img/pic.png" alt />
                <div slot="suffix" class="imgbox" @click="getForgetImg">
                  <img :src="pic" alt />
                </div>
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                v-decorator="['smsCaptcha', {initialValue: formData.smsCaptcha,rules: [{ required: true, message: '请输入手机验证码', whitespace: true}]}]"
                placeholder="请输入手机验证码"
                :max-length="6"
                autocomplete="new-password"
                @change="getFieldsValueData"
              >
                <img slot="prefix" src="@/assets/img/sms.png" alt />
                <div slot="suffix" class="countdown">
                  <a-button :disabled="disabled" :size="'small'" @click="getCode">
                    <span v-if="!disabled">点击获取验证码</span>
                    <a-statistic-countdown
                      v-else
                      :value="deadline"
                      format="ss"
                      :value-style="valueStyle"
                      @finish="timeFinish"
                    />
                  </a-button>
                </div>
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                v-decorator="['firstPwd', {initialValue: formData.firstPwd,rules: [{ validator: passwordValidator, trigger: 'change'}]}]"
                placeholder="请输入密码"
                :max-length="16"
                autocomplete="new-password"
                type="password"
                @change="getFieldsValueData"
              >
                <img slot="prefix" src="@/assets/img/pwd.png" alt />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                v-decorator="['secondPwd', {initialValue: formData.secondPwd,rules: [{ validator: password2Validator, trigger: 'change'}]}]"
                placeholder="请确认新密码"
                :max-length="16"
                type="password"
                @change="getFieldsValueData"
              >
                <img slot="prefix" src="@/assets/img/newpwd.png" alt />
              </a-input>
            </a-form-item>
            <a-button
              :loading="loading"
              :disabled="carryOut"
              class="login-btn"
              size="large"
              type="primary"
              @click='onSubmit'
            >确定</a-button>
          </a-form>
        </div>
      </div>
    </div>
    <div v-else class="callBackBox">
      <img v-if="modifyFlag" class="ok" src="@/assets/img/ok.png" alt />
      <img v-else class="err" src="@/assets/img/err.png" alt />
      <p class="tips">{{modifyFlag ? '密码修改成功！' : '网络异常，密码修改失败！'}}</p>
      <a-button
        v-if="modifyFlag"
        size="large"
        html-type="submit"
        type="primary"
        @click="toLogin"
      >去登录</a-button>
      <a-button v-else size="large" html-type="submit" type="primary" @click="toReset">重新找回</a-button>
    </div>
    <p class="copyright">版权所有：成都运荔枝科技有限公司 备案号：蜀ICP备19017829号-1</p>
  </div>
</template>

<script>
import {
  validate,
  cellPhoneValidator,
} from "@/utils/validate";
import { isEmpty } from "../../utils/type";
import { Forgetimg, ForgetCode, ForgetPassword } from "./api/auth/index";

const ErrorArray = [
  {
    KEY: "smsCaptcha",
    VALUE: "验证码",
  },
  {
    KEY: "secondPwd",
    VALUE: "两次输入密码不一致",
  },
  {
    KEY: "mobile",
    VALUE: "手机号不存在",
  },
  {
    KEY: "mobile",
    VALUE: "该货主已被禁用",
  },
];
const PicArray = [
  {
    KEY: "picCaptcha",
    VALUE: "验证码",
  },
  {
    KEY: "mobile",
    VALUE: "手机号不存在",
  },
  {
    KEY: "mobile",
    VALUE: "该货主已被禁用",
  },
];

export default {
  name: "Login",
  data() {
    // 针对密码的校验
    const passwordValidator = validate(value => {
      if(isEmpty(value)) {
        return '请输入密码'
      }
      if (value && this.form.getFieldValue('secondPwd')) {
        this.form.validateFields(['secondPwd']);
      }
      // 6-16个字符，至少一个字母和一个数字
      const reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,16}$/
      if(!reg.test(value)) {
        return '请输入6-16个字符,至少一个字母和一个数字'
      }
      return undefined
    })
    const password2Validator = validate((value) => {
      if (isEmpty(value)) {
        return "请输入密码";
      }
      const { firstPwd } = this.form.getFieldsValue(["firstPwd"]);
      if (value !== firstPwd) {
        return "两次密码输入不一致";
      }
    });

    return {
      formData: {
        mobile: "",
        smsCaptcha: "",
        picCaptcha: "",
        firstPwd: "",
        secondPwd: "",
      },
      cellPhoneValidator,
      password2Validator,
      passwordValidator,
      loading: false,
      error: "",
      form: this.$form.createForm(this),
      deadline: 0,
      disabled: false,
      valueStyle: {
        "font-size": "14px",
      },
      carryOut: true,
      pic: null,
      picKey: "",
      step: false,
      modifyFlag: true,
    };
  },
  computed: {},
  created() {
    this.getForgetImg();
  },
  mounted() {},
  methods: {
    onSubmit() {
      try {
        this.form.validateFields((errors, values) => {
          if (!errors) {
            ForgetPassword(values)
            .then(() => {
              this.step = true;
              this.modifyFlag = true;
              this.$message.success("密码修改成功!");
            })
            .catch((err) => {
              this.errorMsg(err, ErrorArray)
            });
          }
        });
      } catch {
        this.step = true;
        this.modifyFlag = false;
      }
    },
    toLogin() {
      this.$router.replace("/login");
    },
    errorMsg(err, data) {
      if (err.data && err.data.msg) {
        const errData = err.data.msg.split("(");
        data.forEach((e) => {
          if (errData[0].includes(e.VALUE)) {
            this.form.setFields({
              // eslint-disable-next-line no-useless-computed-key
              [e.KEY]: {
                errors: [new Error(err.data.msg)],
              },
            });
          }
        });
      }
    },
    toReset() {
      this.step = false;
      this.form.resetFields();
    },
    getForgetImg() {
      Forgetimg().then((res) => {
        this.pic = res.pic;
        this.picKey = res.picKey;
      });
    },
    getCode() {
      this.form.validateFields(["mobile", "picCaptcha"], (error) => {
        if (!error) {
          const formData = this.form.getFieldsValue();
          const upData = {
            picCaptcha: formData.picCaptcha,
            picKey: this.picKey,
            mobile: formData.mobile,
            smsType: 'CUSTOMER_RETRIEVE_PWD',
          };
          ForgetCode(upData).then(() => {
            this.$message.success("验证码发送成功");
            this.disabled = !this.disabled;
            this.deadline = Date.now() + 1000 * 60;
          }).catch((err) => {
            this.errorMsg(err, PicArray)
            this.getForgetImg()
          });
        }
      });
    },
    timeFinish() {
      this.disabled = !this.disabled;
    },
    getFieldsValueData() {
      this.$nextTick(() => {
        const formData = this.form.getFieldsValue();
        const value = Object.values(formData);
        if (value.includes("")) {
          this.carryOut = true;
        } else {
          this.carryOut = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login-wrapper {
  height: 100vh;
  overflow: auto;
  .copyright {
    text-align: center;
    width: 100%;
    position: absolute;
    bottom: 20px;
    font-size: 14px;
    color: #999999;
    line-height: 21px;
  }
  .login-content-box {
    width: 100%;
    overflow: hidden;
    position: relative;
  }
  .login-logo {
    height: 80px;
    // width: 200px;
    background: #ffffff;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.1);
    img {
      width: 200px;
      margin-top: 16px;
      margin-left: 50px;
      &:hover{
        cursor: pointer;
      }
    }
  }
  .login-background-image {
    position: absolute;
    left: 232px;
    top: 40px;
    width: 778px;
    height: calc(100vh - 256px);
    img {
      width: 778px;
      height: 550px;
    }
  }
  .form-wrapper {
    padding-top: 2%;
    border-radius: 8px;
    ::v-deep {
      .ant-input-prefix {
        color: #666666;
        opacity: 0.65;
      }
      .ant-input {
        border: 0;
        border-bottom: 1px solid #cccccc;
        border-radius: 0;
        box-shadow: none;
        padding-left: 46px;
      }
    }
  }
  .form-header {
    font-size: 24px;
    margin-bottom: 5%;
    font-weight: bold;
    text-align: center;
    width: 100%;
    color: #171717;
  }
  .login-form {
    width: 380px;
  }
  .login-btn {
    margin-top: 50px;
    width: 100%;
  }
  .countdown {
    width: 130px;
    height: 36px;
    position: absolute;
    bottom: -10px;
    right: 0;
    button {
      width: 100%;
      height: 100%;
    }
  }
  .imgbox {
    width: 130px;
    height: 38px;
    position: absolute;
    bottom: -10px;
    right: 0;
    img {
      width: 100%;
      height: 100%;
      &:hover{
        cursor: pointer;
      }
    }
  }
  /deep/ .ant-btn-primary[disabled] {
    background: #d8d8d8;
    color: #fff;
  }
}
.callBackBox {
  text-align: center;
  margin-top: 120px;
  button {
    width: 400px;
    font-size: 18px;
    height: 54px;
  }
  .tips {
    margin: 16px 0 60px 0;
    color: #171717;
    font-size: 20px;
  }
  .ok {
    width: 60px;
    height: 68px;
  }
  .err {
    width: 60px;
    height: 60px;
  }
}
</style>
